import {SimplePresentationRunnerController} from "../../../core/winpresentation/SimplePresentationRunner";
import {gsap} from "gsap";
import {BenjiKIV} from "../../BenjiKIV";
import {BenjiKIVGameMode} from "../../server/BenjiKIVGameMode";

/**
 * Created by Jerker Nord on 2022-12-02.
 */

export class BenjiKIVOverlayScatterRunner {

    private _mainTL:gsap.core.Timeline;
    private _controller:SimplePresentationRunnerController;
    private _run:boolean = false;

    public shouldRun():boolean {
        return this._run;
    }

    public start(controller:SimplePresentationRunnerController):void {
        this._controller = controller;
        this._mainTL = gsap.timeline({onComplete : () => this.onComplete()});
        this._mainTL.add(() => controller.finish());
        //The game flow doesn't wait for this animation to complete.
        //It tells the scatter result class when it's done
        this._mainTL.add([
            BenjiKIV.overlayScatterView.getAnimateAllRandomTL(),
            () => BenjiKIV.enhancerView.activateAllFighters(),
            () => {
                for(let i:number = 0; i < 5; i++) {
                    BenjiKIV.allReelView.reelModels[i].reelView.activateDarkReel();
                }
            }
        ]);
    }

    //Called from scatterResultRunner
    public skip():void {
        if(this._mainTL && this._mainTL.isActive()) {
            this._mainTL.pause();
            this._mainTL.kill();
            this.onComplete();
        }
    }

    protected onComplete():void {
        if(BenjiKIV.model.data.mode == BenjiKIVGameMode.NORMAL_EXTRA_SPIN) {
            BenjiKIV.respinResult.scatterResultRunner.randomOverlayAnimationComplete = true;
        } else if(BenjiKIV.model.data.mode == BenjiKIVGameMode.FREESPIN) {
            BenjiKIV.freeSpinResult.scatterResultRunner.randomOverlayAnimationComplete = true;
        } else if(BenjiKIV.model.data.mode == BenjiKIVGameMode.SUPER_FREESPIN) {
            BenjiKIV.superFSResult.scatterResultRunner.randomOverlayAnimationComplete = true;
        }
    }

    set run(value:boolean) {
        this._run = value;
    }

    get run():boolean {
        return this._run;
    }
}